module.exports = __webpack_public_path__ + "static/img/6.ae85e28.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/6.jpg
// module id = qKUs
// module chunks = 1